import type { VisitsFromFilterDto } from "app/pages/sales-intelligence/domain/leads/types/filter-values";
import { FilterPanelBaseFilter } from "app/pages/sales-intelligence/modules/advanced-search-filtering/models/BaseFilter";
import type { ICountryObject } from "app/services/CountryService";
import { WORLDWIDE_COUNTRY_ID } from "app/services/countryServiceConst";
import type { IRegionObject } from "app/services/RegionService";

interface IVisitsFromFilterOptions {
    readonly countries: readonly ICountryObject[];
    readonly regions: readonly IRegionObject[];
}

type VisitsFromFilterOptionsDeps = {
    readonly initialDtoValue: readonly number[];
    readonly options: IVisitsFromFilterOptions;
};

class VisitsFromFilterModel extends FilterPanelBaseFilter<VisitsFromFilterDto, IVisitsFromFilterOptions> {
    readonly countriesById: Readonly<{ [key: number]: ICountryObject }>;
    readonly regionsById: Readonly<{ [key: number]: IRegionObject }>;

    constructor({ initialDtoValue, options }: VisitsFromFilterOptionsDeps) {
        super({
            options,
            initialDtoValue: initialDtoValue,
        });

        this.countriesById = options.countries.reduce(
            (acum, country) => ({
                ...acum,
                [country.id]: country,
            }),
            {},
        );

        this.regionsById = options.regions.reduce(
            (acum, region) => ({
                ...acum,
                [region.id]: region,
            }),
            {},
        );
    }

    isWorldwideAvailable() {
        return typeof this.countriesById[WORLDWIDE_COUNTRY_ID] !== "undefined";
    }

    getInitialDtoValue(): VisitsFromFilterDto {
        return this.initialDtoValue ?? [];
    }

    fromApiValue(value?: VisitsFromFilterDto): VisitsFromFilterDto {
        if (value === undefined) {
            return this.getInitialDtoValue();
        }

        return value;
    }

    isFilterDirty(currentValue: VisitsFromFilterDto | undefined): boolean {
        if (currentValue === undefined) {
            return false;
        }

        const initialValue = this.getInitialDtoValue();

        return (
            currentValue.length !== initialValue.length || currentValue.some((id, index) => id !== initialValue[index])
        );
    }
}

export default VisitsFromFilterModel;
